import React from 'react';
import PropTypes from 'prop-types';

import {List, ListItem, Stack, Typography} from 'views/components';
import {FavoriteBorderOutlined} from 'views/icons';
import {Translate} from 'views/module';

import CardPaper from './CardPaper';

const CareNeedsCard = (props) => {
  const {requirements} = props;

  return (
    <CardPaper>
      <Stack direction="row" spacing={1} alignItems="center" sx={{mb: 1}}>
        <FavoriteBorderOutlined fontSize="small" />
        <Typography variant="body2" sx={{fontWeight: 700}}>
          <Translate expression='jobDetail.CarePlan.Title' />
        </Typography>
      </Stack>

      <List
        disablePadding
        sx={{
          m: 0,
          p: 0,
          listStyleType: 'disc',
          pl: 2.5,
        }}
      >
        {
          requirements.careNeeds.map((needs, i) => (
            <ListItem
              key={i}
              disableGutters
              disablePadding
              sx={{
                display: 'list-item',
                py: 0.15,
                color: 'text.secondary',
              }}
            >
              <Typography variant="body2" sx={{color: 'text.secondary'}}>
                <Translate expression={`jobDetail.CarePlan.Options.${needs}.Label`} />
              </Typography>
            </ListItem>
          ))
        }
      </List>
    </CardPaper>
  );
};

CareNeedsCard.propTypes = {
  requirements: PropTypes.object.isRequired,
};

export default CareNeedsCard;
